/**
 * Знак Switch Inspector: линза, в которой порт RJ45, — «осмотр портов».
 *
 * Без плитки: знак рисуется линиями в цвете текста, как значки разделов,
 * и не выделяется на фоне ни в светлой, ни в тёмной теме. Цветной — только
 * порт внутри линзы (--logo-accent: синий в светлой теме, голубой в тёмной).
 *
 * Тот же рисунок — в public/favicon.svg (цвета по теме браузера) и в
 * иконках приложения (светлый фон, PNG, отрисованы из того же SVG).
 */
export function LogoMark({ size = 28, className, title }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      role={title ? 'img' : undefined}
      aria-label={title || undefined}
      aria-hidden={title ? undefined : 'true'}
      focusable="false"
    >
      <circle cx="13.5" cy="13.5" r="9.2" strokeWidth="2.6" />
      <path d="M20.6 20.6L27.2 27.2" strokeWidth="3.4" />
      <path
        d="M9.2 10.3h8.6v4.9h-2.15v1.9h-4.3v-1.9H9.2z"
        stroke="none"
        style={{ fill: 'var(--logo-accent, #1D6FA4)' }}
      />
    </svg>
  );
}
